
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "VolumeBars501740436",
      {"classes":{"root":"VolumeBars501740436__root","container":"VolumeBars501740436__container","barItemContainer":"VolumeBars501740436__barItemContainer","bar":"VolumeBars501740436__bar"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  